import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const translations = {
  en: {
    // Navigation
    navHome: 'Home',
    navShop: 'Shop',
    navCustomOrder: 'Custom Order',
    navMyOrders: 'My Orders',
    navWishlist: 'Wishlist',
    navCart: 'Cart',
    navAccount: 'Account',
    navSignIn: 'Sign In',
    navSignOut: 'Sign Out',
    navSearch: 'Search',

    // Hero & Home
    heroTag: 'New Season 2026',
    heroTitle: 'Crafted Elegance. Modern Silhouette.',
    heroSubtitle: 'Explore our latest international luxury collections designed between Ghana and China.',
    shopNow: 'Shop Collection',
    trendingNow: 'Trending Now',
    featuredProducts: 'Featured Products',
    allProducts: 'All Products',
    viewDetails: 'View Details',
    addToCart: 'Add to Cart',
    addedToCart: 'Added to cart',
    outOfStock: 'Out of Stock',
    inStock: 'In Stock',
    buyNow: 'Buy Now',
    selectColor: 'Color',
    selectSize: 'Select Size',
    selectOption: 'Select Option',
    size: 'Size',
    color: 'Color',
    aboutProduct: 'About this product',
    specifications: 'Specifications',
    customerReviews: 'Customer Reviews',
    noReviews: 'No reviews yet for this product.',
    newArrival: 'New Arrival',
    soldOut: 'Sold Out',

    // Cart & Checkout
    myCart: 'My Shopping Bag',
    emptyCartTitle: 'Your Bag is Empty',
    emptyCartSubtitle: 'Discover our catalog and add items you love.',
    continueShopping: 'Continue Shopping',
    subtotal: 'Subtotal',
    shipping: 'Shipping',
    freeShipping: 'FREE',
    tax: 'Estimated Tax',
    discount: 'Discount',
    discountApplied: 'Discount Applied',
    total: 'Total',
    checkout: 'Proceed to Checkout',
    remove: 'Remove',
    quantity: 'Quantity',
    promoCode: 'Promo Code',
    enterCode: 'ENTER CODE',
    apply: 'Apply',
    orderSummary: 'Order Summary',
    shippingAddress: 'Shipping Address',
    paymentMethod: 'Payment Method',
    placeOrder: 'Place Order',
    processing: 'Processing...',
    addNewAddress: '+ Add New',
    cancel: 'Cancel',
    saveAddress: 'Save Address',
    noAddressesSaved: 'No addresses saved.',
    useCurrentLocation: 'Use My Current Location',
    saveForFuture: 'Save for future purchases',
    onlinePayment: 'Online Payment',
    payWithCard: 'Pay with Card or Mobile Money',

    // Custom Order
    customOrderTitle: 'Bespoke Custom Orders',
    customOrderSubtitle: 'Can’t find what you are looking for? Describe your vision and upload reference photos. Our production team in China and Ghana will craft it for you.',
    whatAreYouLookingFor: 'What are you looking for?',
    specsPlaceholder: 'Provide materials, measurements, color preferences, and details...',
    uploadReference: 'Upload Reference Images',
    dragDropImages: 'Drag and drop images here, or browse',
    submitBespokeRequest: 'Submit Bespoke Request',
    requestSubmittedSuccess: 'Your request has been submitted! Our team will review and send a quote.',
    signInRequired: 'Sign In Required',
    signInRequiredSubtitle: 'Please sign in to your account to submit a custom product request.',
    signInNow: 'Sign In Now',

    // Account & Settings
    settings: 'Settings',
    accountSettings: 'Account Settings',
    editProfile: 'Edit Profile',
    changePassword: 'Change Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email Address',
    phone: 'Phone Number',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
    saveChanges: 'Save Changes',
    language: 'Language',
    preferences: 'Preferences',
    legal: 'Legal & Privacy',
    termsOfService: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',

    // Orders
    myOrdersTitle: 'My Orders',
    myActivityTitle: 'My Activity',
    myActivitySubtitle: 'Track your recent purchases and bespoke custom requests.',
    ordersTab: 'Orders',
    customRequestsTab: 'Custom Requests',
    orderId: 'Order ID',
    orderDate: 'Order Date',
    orderStatus: 'Status',
    statusPending: 'Pending',
    statusProcessing: 'Processing',
    statusShipped: 'Shipped',
    statusDelivered: 'Delivered',
    statusCancelled: 'Cancelled',
    statusCompleted: 'Completed',
    statusQuoted: 'Quoted',
    statusRejected: 'Rejected',
    viewOrder: 'View Order',
    backToOrders: 'Back to Orders',
    orderPlacedOn: 'Placed on',
    timeline: 'Shipment Tracking',
    customerInfo: 'Customer Information',

    // Wishlist & Search
    myWishlist: 'My Wishlist',
    emptyWishlistTitle: 'Your Wishlist is Empty',
    emptyWishlistSubtitle: 'Save items you love to view them here later.',
    startShopping: 'Start Shopping',
    searchResults: 'Search Results',
    allCategories: 'All Categories',
    filterByCategory: 'Category',
    noItemsFound: 'No products found',

    // Auth
    signInTitle: 'Sign In',
    signInSubtitle: 'Your gateway to global trade.',
    registerTitle: 'Create Account',
    registerSubtitle: 'Join our international luxury platform.',
    createAccount: 'Create Account',
    alreadyHaveAccount: 'Already have an account?',
    newHere: 'New here?',
    forgotPassword: 'Forgot Password?',
    otpVerification: 'Verify Your Identity',
    otpSubtitle: 'Enter the verification code sent to your phone or email.',
    verifyAndComplete: 'Verify & Complete Registration',

    // Footer
    copyright: '© 2026 VERSARC. All rights reserved.',
    footerCollab: 'A global partnership between Sorammi Arc (Ghana) & Solammi Wenzhou Information Technology Co., Ltd. (China).',
    aboutUs: 'About Us',
    contactUs: 'Contact Us',
    helpCenter: 'Help Center',
  },

  zh: {
    // Navigation
    navHome: '首页',
    navShop: '商城',
    navCustomOrder: '定制订单',
    navMyOrders: '我的订单',
    navWishlist: '心愿单',
    navCart: '购物车',
    navAccount: '个人中心',
    navSignIn: '登录',
    navSignOut: '退出登录',
    navSearch: '搜索',

    // Hero & Home
    heroTag: '2026全新系列',
    heroTitle: '匠心精制 • 现代优雅',
    heroSubtitle: '探索加纳与中国联合打造的最新跨国轻奢时尚系列。',
    shopNow: '探索系列',
    trendingNow: '当季热销',
    featuredProducts: '精选商品',
    allProducts: '所有商品',
    viewDetails: '查看详情',
    addToCart: '加入购物车',
    addedToCart: '已加入购物车',
    outOfStock: '缺货中',
    inStock: '现货',
    buyNow: '立即购买',
    selectColor: '颜色',
    selectSize: '选择尺码',
    selectOption: '选择规格',
    size: '尺码',
    color: '颜色',
    aboutProduct: '商品详情',
    specifications: '产品规格参数',
    customerReviews: '顾客评价',
    noReviews: '该商品暂无评价。',
    newArrival: '新品上市',
    soldOut: '已售罄',

    // Cart & Checkout
    myCart: '我的购物车',
    emptyCartTitle: '购物车空空如也',
    emptyCartSubtitle: '浏览精选系列，将心仪的商品加入购物车。',
    continueShopping: '继续挑选',
    subtotal: '商品小计',
    shipping: '运费',
    freeShipping: '包邮',
    tax: '预估税费',
    discount: '优惠减免',
    discountApplied: '已应用优惠',
    total: '总计',
    checkout: '立即结算',
    remove: '移除',
    quantity: '数量',
    promoCode: '优惠码',
    enterCode: '输入优惠码',
    apply: '应用',
    orderSummary: '订单摘要',
    shippingAddress: '收货地址',
    paymentMethod: '支付方式',
    placeOrder: '提交订单',
    processing: '正在处理中...',
    addNewAddress: '+ 添加新地址',
    cancel: '取消',
    saveAddress: '保存收货地址',
    noAddressesSaved: '暂无保存的收货地址。',
    useCurrentLocation: '使用当前GPS定位',
    saveForFuture: '保存以便将来使用',
    onlinePayment: '在线安全支付',
    payWithCard: '使用银行卡或移动支付安全付款',

    // Custom Order
    customOrderTitle: '专属定制订单',
    customOrderSubtitle: '找不到心仪款式？描述您的需求并上传参考图片，我们位于中国与加纳的定制工坊将为您量身打造。',
    whatAreYouLookingFor: '您期望定制的商品名称',
    specsPlaceholder: '详细描述面料、尺寸、颜色细节及定制要求...',
    uploadReference: '上传参考图片',
    dragDropImages: '拖拽图片至此，或点击浏览',
    submitBespokeRequest: '提交定制需求',
    requestSubmittedSuccess: '您的定制需求已成功提交！我们的团队将尽快评估并向您提供报价。',
    signInRequired: '请先登录账号',
    signInRequiredSubtitle: '请登录您的VERSARC账号后提交专属定制需求。',
    signInNow: '立即登录',

    // Account & Settings
    settings: '系统设置',
    accountSettings: '账号设置',
    editProfile: '编辑资料',
    changePassword: '修改密码',
    firstName: '名',
    lastName: '姓',
    email: '电子邮箱',
    phone: '联系电话',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    saveChanges: '保存更改',
    language: '语言设置 / Language',
    preferences: '系统偏好',
    legal: '法律与隐私',
    termsOfService: '服务条款',
    privacyPolicy: '隐私政策',

    // Orders
    myOrdersTitle: '我的订单',
    myActivityTitle: '我的交易记录',
    myActivitySubtitle: '查看并追踪您的商城订单与专属定制需求。',
    ordersTab: '商城订单',
    customRequestsTab: '专属定制',
    orderId: '订单编号',
    orderDate: '下单时间',
    orderStatus: '订单状态',
    statusPending: '待付款 / 待确认',
    statusProcessing: '配货中',
    statusShipped: '已发货',
    statusDelivered: '已送达',
    statusCancelled: '已取消',
    statusCompleted: '已完成',
    statusQuoted: '已出报价',
    statusRejected: '已拒绝',
    viewOrder: '查看订单详情',
    backToOrders: '返回订单列表',
    orderPlacedOn: '下单日期',
    timeline: '物流轨迹',
    customerInfo: '收件人信息',

    // Wishlist & Search
    myWishlist: '我的心愿单',
    emptyWishlistTitle: '心愿单空空如也',
    emptyWishlistSubtitle: '收藏心仪商品，随时回来查看。',
    startShopping: '开始选购',
    searchResults: '搜索结果',
    allCategories: '全部类目',
    filterByCategory: '商品分类',
    noItemsFound: '未找到相关商品',

    // Auth
    signInTitle: '登录',
    signInSubtitle: '开启您的全球轻奢贸易之门。',
    registerTitle: '注册账号',
    registerSubtitle: '加入VERSARC跨国时尚轻奢会员。',
    createAccount: '立即注册',
    alreadyHaveAccount: '已有账号？',
    newHere: '新用户？',
    forgotPassword: '忘记密码？',
    otpVerification: '身份验证',
    otpSubtitle: '请输入发送至您手机或邮箱的验证码。',
    verifyAndComplete: '验证并完成注册',

    // Footer
    copyright: '© 2026 VERSARC. 保留所有权利。',
    footerCollab: 'Sorammi Arc（加纳）与 温州索拉米信息科技有限公司（中国）跨国战略合作项目。',
    aboutUs: '关于我们',
    contactUs: '联系我们',
    helpCenter: '帮助中心',
  },
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguageState] = useState(() => {
    try {
      return localStorage.getItem('versarc_lang') || 'en';
    } catch {
      return 'en';
    }
  });

  const setLanguage = (lang) => {
    const target = lang === 'zh' ? 'zh' : 'en';
    setLanguageState(target);
    try {
      localStorage.setItem('versarc_lang', target);
    } catch {}
  };

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'zh' : 'en');
  };

  const t = (key, fallback = '') => {
    return translations[language]?.[key] || translations.en?.[key] || fallback || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t, isChinese: language === 'zh' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    return {
      language: 'en',
      setLanguage: () => {},
      toggleLanguage: () => {},
      t: (key, fallback = '') => translations.en?.[key] || fallback || key,
      isChinese: false
    };
  }
  return context;
};
